// extracted by mini-css-extract-plugin
module.exports = {"loadingSpinnerWrapper":"Loading_loadingSpinnerWrapper__yUing","loadingSpinner":"Loading_loadingSpinner__9Xwld","spin":"Loading_spin__W__Iz"};